import React, { Component, ComponentType, ErrorInfo, PropsWithChildren } from 'react';
import ErrorComponent from '../Error';

interface ErrorBoundaryProps {
  FallbackComponent?: ComponentType<{ error?: Error }>;
  onError?: (error: Error, componentStack: string) => void;
}

interface ErrorBoundaryState {
  error?: Error;
}

class ErrorBoundary extends Component<PropsWithChildren<ErrorBoundaryProps>, ErrorBoundaryState> {
  constructor(props: PropsWithChildren<ErrorBoundaryProps>) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    const { onError } = this.props;
    if (onError) {
      try {
        onError(error, info?.componentStack ?? '');
      } catch (err) {}
    }
  }

  render(): React.ReactNode {
    const { children, FallbackComponent = ErrorComponent } = this.props;
    const { error } = this.state;
    if (!!error) {
      return <FallbackComponent />;
    }

    return <>{children}</>;
  }
}

export default ErrorBoundary;
